import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Avatar from '@material-ui/core/Avatar';
import InputAdornment from '@material-ui/core/InputAdornment';
import Divider from '@material-ui/core/Divider';
import Hidden from '@material-ui/core/Hidden';

import { useAuth } from '../../../contexts/auth';
import { AtSignIcon } from '../../../assets/icons';
import useCommonStyles from '../../../styles/common';
import useStyles from '../styles';

const MyData = () => {
  const { user } = useAuth();
  const classes = useStyles();
  const commonClasses = useCommonStyles();

  return (
    <Grid item md={9} lg={6}>
      <Box className={classes.topContainer}>
        <Avatar src={user.image} alt={user.firstName} className={classes.userAvatar}>
          {user.firstName.substr(0, 1)}
        </Avatar>
        <Box className={classes.helloContainer}>
          <Typography variant="h2">Olá {user.firstName}</Typography>
          <Typography>Matrícula - {user.gpId}</Typography>
        </Box>
      </Box>

      <Hidden smUp>
        <Divider variant="middle" /* className={classes.divider} */ />
        <Box mt={2} mb={4}>
          <Typography variant="h2" className={classes.title}>Meus Dados</Typography>
        </Box>
      </Hidden>

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <TextField
            label="Nome Completo"
            defaultValue={`${user.firstName} ${user.lastName}`}
            size="small"
            InputProps={{
              className: commonClasses.inputs,
            }}
            disabled
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="E-mail"
            defaultValue={user.email}
            size="small"
            InputProps={{
              'className': commonClasses.inputs,
              endAdornment: (
                <InputAdornment position="end">
                  <AtSignIcon />
                </InputAdornment>
              )
            }}
            disabled
          />
        </Grid>
      </Grid>
    </Grid>

  );
}

export default MyData;